// add-comments-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-payapp-comments-dialog',
    templateUrl: './payapp-comments-dialog.component.html',
    styleUrls: ['./payapp-comments-dialog.component.scss'],
    standalone: false
})
export class PayappCommentsDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<PayappCommentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { comments: string; quantity?: number; remaining?: number; maxPayable?: number; item?: string }
  ) {}

  onCancelClick(): void {
    this.dialogRef.close();
  }

  get isPartial(): boolean { return this.data.remaining != null; }

  readonly quantityErrorMatcher = { isErrorState: () => !!this.quantityError };

  get quantityError(): string {
    if (!this.isPartial) return '';
    const qty = Number(this.data.quantity);
    if (this.data.quantity == null || !Number.isFinite(qty)) return 'Enter a quantity to pay now.';
    if (qty < 0) return 'Quantity cannot be less than 0.';
    if (qty > this.data.maxPayable) {
      const limit = this.data.maxPayable.toLocaleString('en-US', { maximumFractionDigits: 8 });
      return this.data.maxPayable < this.data.remaining
        ? `Maximum payable is ${limit} under the approved contract.`
        : `Maximum payable is ${limit}, the remaining unpaid quantity for this item.`;
    }
    if (Math.round(qty * 1e8) / 1e8 !== qty) return 'Use no more than 8 decimal places.';
    return '';
  }

  get valid(): boolean {
    if (this.quantityError) return false;
    return (this.isPartial && Number(this.data.quantity) === this.data.remaining) || !!this.data.comments?.trim();
  }

  onConfirmClick(): void {
    if (!this.valid) return;
    const comments = this.data.comments?.trim() || '';
    this.dialogRef.close(this.isPartial ? { quantity: Number(this.data.quantity), comments } : comments);
  }
}
